module.exports = __webpack_public_path__ + "img/banner-sm-05.bbead703.jpg";